import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, Suspense as _Suspense, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d28bd1f"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "goods-title" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "rel" }
const _hoisted_5 = {
  key: 0,
  class: "addition-content"
}
const _hoisted_6 = { class: "addition-tag" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "addition-list-content" }
const _hoisted_9 = { class: "line--2" }
const _hoisted_10 = { style: {"max-width":"300px"} }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "fcolor ft-w-6 mr_10" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" (")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(") ")
const _hoisted_16 = { key: 1 }

import { computed, ref } from 'vue'
import { formatMoney } from '@/plugins/utils'
import { t } from '@/plugins/i18n'
import TableLike from '@/components/common/TableLike.vue'
import { addGpAdt } from '@/apis/shopcart'
import { goodsPropName } from '@/util/useFormat'
import GoodsLink from '@/components/common/GoodsLink.vue'
import AdditionDrawer from '@/components/additional/AdditionDrawer.vue'
import { BASE_IMAGE } from '@/common/baseImage'
import { montageAddition, isConfirmWashAdditionCustomerSku } from '@/util/calcAdt'
import Tipstishi from '@/components/IconPark/Tipstishi.vue'
import { sourceCountryRef, tCurrency } from '../country'
import { COUNTRY } from '@/global'


export default /*#__PURE__*/_defineComponent({
  props: ['checked', 'mode', 'list'],
  emits: ['update'],
  setup(__props, { emit }) {

const props = __props


const countryCode = computed(() => props.mode === 1 ? sourceCountryRef.value : (sourceCountryRef.value === COUNTRY.JP ? COUNTRY.CN : sourceCountryRef.value))
const layout = [
  { label: '图片', prop: 'productSkuImg', width: 160, slotName: 'image' },
  { label: '商品名称', prop: 'productTitleJp', width: 200, slotName: 'title' },
  {
    label: '商品规格',
    prop: 'productPropertiesName',
    width: 200,
    pipe: (v: any, item: any) => goodsPropName(item).join(';')?.replace('颜色', t('颜色2'))?.replace('尺码', t('尺码'))
  },
  { label: '单价', prop: 'price', width: 200, fix: (t: any) => t + tCurrency('CNY') },
  { label: '单组数量', prop: 'unitNums', width: 200 },
  {
    label: '购买数量',
    prop: 'buyQuantity',
    width: 100,
    slotName: 'buyQuantity'
  },
  { label: '商品附加项', prop: 'a', width: 200, slotName: 'additon' },
  // {
  //   label: '待组合库存数量（截止时间）',
  //   prop: 'matchStore',
  //   width: 200,
  //   slotName: 'store'
  // },
  {
    label: '使用库存/采购数量', slotName: 'store_buy', width: 110
  }
].fort()
const columns = computed(() => (props.mode ? layout.slice(0, 6).concat([layout[6]]) : layout.slice(0, -1)))
const width = computed(() => columns.value.reduce((acc, v) => acc + v.width, 0))

const proxy: any = ref({})
const handleAdt = (t: any, cartId = proxy.value.cartId, shopProductSku = proxy.value.shopProductSku) => {
  const cartAdditionList = Array.isArray(t) ? t : []
  const noAdditionalFlag = t === 1 ? t : 0
  addGpAdt({
    cartId,
    shopProductSku,
    noAdditionalFlag,
    cartAdditionList
  }).then(() => {
    emit('update')
  })
}

const oemType = (type: any) => {
  return t([1, 3].includes(type) ? '样品单' : '大货单')
}

const canAddAdt = (goods: any) => {
  if (goods.productType === 1) return true
  if (goods.productType === 2) {
    if (
      // [2, 4].includes(goods.oemOrderType) &&
      goods.oemProductClassificationId !== 3
    ) {
      return true
    } else {
      goods.noAdditionalFlag = 1
    }
  }
}

const changeAdt = (goods: any) => {
  proxy.value = { ...goods }
}
const noAdd = (goods: any) => {
  handleAdt(1, goods.cartId, goods.shopProductSku)
}

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TableLike, {
      columns: _unref(columns),
      data: __props.list,
      itemClass: "row",
      style: {"width":"1160px"}
    }, {
      image: _withCtx(({ item }) => [
        _createElementVNode("img", {
          referrerPolicy: "no-referrer",
          class: "goods-pic img-active",
          src: item.productSkuImg?.split(',')[0] || item.productMainImg || _unref(BASE_IMAGE),
          alt: ""
        }, null, 8, _hoisted_1)
      ]),
      title: _withCtx(({ item }) => [
        _createVNode(GoodsLink, {
          goods: item,
          class: "fx-1"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createTextVNode(_toDisplayString(item.productTitleJp) + " ", 1),
              (item.oemOrderType)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, " (" + _toDisplayString(oemType(item.oemOrderType)) + ") ", 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 2
        }, 1032, ["goods"])
      ]),
      buyQuantity: _withCtx(({ item }) => [
        _createElementVNode("div", _hoisted_4, [
          _createTextVNode(_toDisplayString(item.buyQuantity) + " ", 1),
          _withDirectives(_createElementVNode("div", {
            class: "abs rp-color not-enough",
            style: {"color":"#FE2C55"}
          }, _toDisplayString(_unref(t)('购买数量不可低于X件').replace('X', item.minOrderQuantity)), 513), [
            [_vShow, item.lack]
          ]),
          _withDirectives(_createElementVNode("div", {
            class: "abs rp-color not-enough",
            style: {"color":"#FE2C55"}
          }, _toDisplayString(_unref(t)('按手起批 1手={num}双', { num: item.batchNumber })), 513), [
            [_vShow, !item.lack && item.handLack && item.batchNumber > 0]
          ])
        ])
      ]),
      additon: _withCtx(({ item }) => [
        (canAddAdt(item) && (!(_unref(sourceCountryRef) === _unref(COUNTRY).JP && __props.mode === 1)))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_el_radio, {
                "model-value": !!item.noAdditionalFlag,
                size: "small",
                label: true,
                style: {"margin-right":"0"},
                onChange: ($event: any) => (noAdd(item))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('不需要检品')), 1)
                ]),
                _: 2
              }, 1032, ["model-value", "onChange"]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: _normalizeClass(["tag", (item.noAdditionalFlag === 1 || item.cartAdditionList?.length) ? 'success' : 'error'])
                }, _toDisplayString(item.noAdditionalFlag === 1 ? _unref(t)('不设置') : item.cartAdditionList?.length ? _unref(t)('已设置') : _unref(t)('未设置')), 3),
                _createElementVNode("a", {
                  class: "set",
                  onClick: ($event: any) => (changeAdt(item))
                }, _toDisplayString(item.noAdditionalFlag === 1 ? _unref(t)('变更') : item.cartAdditionList?.length ? _unref(t)('编辑') : _unref(t)('设置')) + ">", 9, _hoisted_7)
              ]),
              _createElementVNode("div", _hoisted_8, [
                (item.additionNameJpSummary)
                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 0,
                      placement: "top",
                      effect: "light"
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(montageAddition)(item.cartAdditionList)), 1)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(montageAddition)(item.cartAdditionList)), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _withDirectives(_createElementVNode("div", { class: "addition-error" }, _toDisplayString(_unref(t)('附加项验证')), 513), [
                [_vShow, !(item.cartAdditionList?.length || item.noAdditionalFlag)]
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, "-"))
      ]),
      store: _withCtx(({ item }) => [
        (item.matchStore)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, _toDisplayString(item.stockQuantity), 1),
              _hoisted_14,
              _createElementVNode("span", null, _toDisplayString(item.matchStore.time), 1),
              _hoisted_15
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_16, "-"))
      ]),
      store_buy: _withCtx(({ item }) => [
        _createElementVNode("div", null, _toDisplayString(__props.checked ? item.stockQuantity : '-') + "/" + _toDisplayString(item.buyQuantity ?? item.orderQuantity), 1)
      ]),
      _: 1
    }, 8, ["columns", "data"]),
    (proxy.value.cartAdditionList)
      ? (_openBlock(), _createBlock(_Suspense, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(AdditionDrawer, {
              list: proxy.value.cartAdditionList,
              "onUpdate:list": _cache[0] || (_cache[0] = ($event: any) => ((proxy.value.cartAdditionList) = $event)),
              proxy: proxy.value,
              onCommit: handleAdt,
              type: "AdtOrder",
              countryCode: _unref(countryCode),
              isConfirmKey: true
            }, null, 8, ["list", "proxy", "countryCode"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})